module.exports = __webpack_public_path__ + "img/carbands.46cf5ba8.png";